/**
 * Reference and Examples: https://easings.net/
 */

export const EaseInOutCubic = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
